import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import VwHbsOrderIlacuygulamaDTO from "src/models/Tedavi/Uygulama/VwHbsOrderIlacuygulamaDTO";

interface ITedaviUygulama {
    open: boolean;
    activeRow: VwHbsOrderIlacuygulamaDTO;
    selectedPlanTarih: string;
};

export const TedaviUygulamaSlice = createSlice<ITedaviUygulama, MapReducerPayloads<ITedaviUygulama, {
    setOpen: boolean;
    setActiveRow: VwHbsOrderIlacuygulamaDTO;
    setSelectedPlanTarih: string;
}>>({
    name: "tedaviUygulama",
    initialState: {
        open: false,
        activeRow: new VwHbsOrderIlacuygulamaDTO(),
        selectedPlanTarih: "",
    },
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
        setSelectedPlanTarih: (state, action) => {
            state.selectedPlanTarih = action.payload;
        },
    },
});
